/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseInstance} from './base-instance';
import {Color} from './color';
import {Location} from './location';
import {Point} from './point';
import {ParentLocationWrapper} from './jaxb/parent-location-wrapper';
import {ZoneInstance} from './zone-instance';

export class LocationInstance extends BaseInstance {
  location: Location;
  parent: ParentLocationWrapper;
  width: number;
  height: number;
  scale: number;
  latitude: number;
  longitude: number;
  altitude: number;
  color: Color;
  textColor: Color;
  perimeterPoints: Point[];
  locked: boolean;
  childLocations: LocationInstance[];
  zones: ZoneInstance[];
}
